import { ButtonHTMLAttributes, forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all disabled:opacity-50 disabled:cursor-not-allowed border-[3px] border-dark",
  {
    variants: {
      variant: {
        primary: "bg-primary text-dark shadow-[6px_6px_0px_0px] shadow-dark hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px] hover:shadow-dark active:translate-x-[4px] active:translate-y-[4px] active:shadow-[2px_2px_0px_0px]",
        secondary: "bg-card text-dark shadow-[6px_6px_0px_0px] shadow-dark hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px] hover:shadow-dark active:translate-x-[4px] active:translate-y-[4px] active:shadow-[2px_2px_0px_0px]",
        outline: "bg-transparent text-dark shadow-[6px_6px_0px_0px] shadow-dark hover:bg-dark hover:text-card hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px] hover:shadow-dark",
        danger: "bg-destructive text-white shadow-[6px_6px_0px_0px] shadow-dark hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px] hover:shadow-dark hover:bg-red-600 active:translate-x-[4px] active:translate-y-[4px] active:shadow-[2px_2px_0px_0px]",
      },
      size: {
        default: "px-6 py-3 text-base",
        sm: "px-4 py-2 text-sm",
        lg: "px-8 py-4 text-lg",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
);

export interface BrutalButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const BrutalButton = forwardRef<HTMLButtonElement, BrutalButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

BrutalButton.displayName = "BrutalButton";

export { BrutalButton, buttonVariants };
